var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sc-table-v2',{ref:"refTable",attrs:{"head":_vm.tableHead,"data":_vm.list,"page":_vm.page,"page-hide":false,"read-table":true,"load":_vm.load,"pop-show":false,"show-add":false,"table-height":_vm.tableHeightCalc,"selection":false},on:{"pageChange":_vm.pageChange,"pageSizesChange":_vm.pageSizesChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }